import $ from 'jquery';

import Common from './base/common';
import Layout from './base/layout';
import BootstrapSelectCompatability from './bootstrap-select-compatability';

// Shared Components
import './components/banner';
import './components/webpimages';
import './components/lazyload';

$(() => {
	const common = new Common();
    common.init();

	const layout = new Layout();
    layout.init();

	const bootstrapSelectCompatability = new BootstrapSelectCompatability();
	bootstrapSelectCompatability.init();
});
